/* eslint-disable no-console */
import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'
import request from './request'
import axios from 'axios'
import { i18n } from 'plugins/i18n.js'
import { EMAIL_REJECTED_CODE, extractEmailRejections, extractEmailWarnings } from '@/helpers/emailRejections.js'

// todo варінт unsubscribe. отписатись від виконання запроса без проміса - watchQuery
// const llll = (await getApolloClient('/tenders'))
//     .watchQuery({
//       query: gql`${tendersFromElastic}`,
//       variables: {tenderSearchParam}
//     })
// let r = llll.subscribe((res) => Vue.prototype.$log('onSubscribe tendersFromElastic', res))
// Vue.prototype.$query_tender = llll
// console.debug('llll', llll, r, 'rrrrrrrrrr', rrrrrrrrrr)
// setTimeout(() => {
//   r.unsubscribe()
// }, 1000)


const st_way = './graphql/smarttender/',
  members_way =  st_way + 'members/',
  tender_way =  st_way + 'tender/',
  resources_way =  st_way + 'resources/',
  mutation_way =  st_way + 'mutations/',
  criteria_way =  st_way + 'criteria/',
  environment = '/tenders'

/**
 * Розділяє результат Apollo, отриманий з errorPolicy 'all', на звіт для кожної електронної пошти
 * (помилки EMAIL_REJECTED + помилки рівня відповіді `extensions.emailWarnings`) та решту помилок.
 */
const splitEmailReport = (res) => ({
  rejected: extractEmailRejections(res?.errors),
  warnings: extractEmailWarnings(res?.extensions),
  errors: (res?.errors || []).filter(error => error?.extensions?.code !== EMAIL_REJECTED_CODE)
})

const checkNeedMessage = (ret, result) => {
  let typeModal = ret?.extensions?.messages?.length ? 'warning' : (
    result
      ? null
      : 'error'
  )

  if (!typeModal) {
    typeModal = ret?.extensions?.code
  }
  let modalText = i18n.t('Errors.STHWrong')

  if (ret?.extensions?.messages?.length) {
    modalText = i18n.t(ret.extensions.messages[0])
  } else {
    modalText = ret?.extensions?.code
  }

  if (typeModal) {
    Vue.prototype.$notice[typeModal]({
      title: typeModal === 'error' ? i18n.t('Common.ErrorTitle') : i18n.t('Common.WarningTitle'),
      message: modalText,
    })
  }
}

export default class SmarttenderApi {
  static loadingNbuRates = {}

  async availableUnits() {
    return await request({environment, type: 'query' , name: 'availableUnits', way: st_way, has_catch: true})
  }

  async getAcceptors(id) {
    return await request( {environment, type: 'query' , name: 'acceptors', variables: {tenderIds: [id]}, way: st_way, has_catch: true} )
  }

  async biddingTypes(organizationId) {
    let biddingTypes = await import(st_way + 'biddingTypes.gql')
    return (await getApolloClient('/tenders', organizationId))
      .query({
        query: gql`${biddingTypes}`,
      })
      // .then(this.biddingTypesCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }


  async counterparty(organizationUsreou) {
    let counterparty = await import(st_way + 'counterparty.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${counterparty}`,
        variables: {organizationUsreou: organizationUsreou}
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }


  async prolongationRule(organizationId) {
    let prolongationRule = await import(st_way + 'prolongationRule.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${prolongationRule}`,
        variables: {organizationId: organizationId}
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async supplierAddress() {
    let supplierAddress = await import(st_way + 'supplierAddress.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${supplierAddress}`
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async currencies() {
    let currencies  = await import(st_way + 'currencies.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${currencies }`
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }


  async getProfile() {
    let resources  = await import(st_way + 'userProfile.gql')
    return (await getApolloClient('/tenders', 0))
      .query({
        query: gql`${ resources }`,
      })
      .then(this.getProfileCallack)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  getProfileCallack(response) {
    let userProfile = response.data.userProfile
    Vue.prototype.$store.commit('setSTProfile', userProfile)
    return userProfile
  }

  async getTendersSettings() {
    let organizationSettings   = await import(st_way + 'getOrganizationSettings.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ organizationSettings  }`,
      })
      .then(this.getgetTendersSettingsCallack)
  }

  getgetTendersSettingsCallack(response) {
    let organisationOptions = response.data.organisationOptions
    Vue.prototype.$store.commit('setTendersSettings', organisationOptions)
    return organisationOptions
  }

  async getCity(name) {
    let city   = await import(st_way + 'city.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ city  }`,
        variables: {cityName: name}
      })
      .then(res => res?.data?.city)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async chatMessages(tenderId) {
    let chatMessages   = await import(st_way + 'chatMessages.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ chatMessages  }`,
        variables: {tenderId}
      })
      .then(res => res?.data?.chatMessages)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getHolidays(from, to) {
    let getHolidays   = await import(st_way + 'getHolidays.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ getHolidays  }`,
        variables: { from, to }
      })
      .then(res => res?.data?.getHolidays)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getFiltersTemplatesByType( typeId) {
    return await request( {
      environment,
      type: 'query',
      name: 'getFiltersTemplatesByType',
      variables: {
        typeId
      },
      way: st_way ,
      has_catch: true
    })
  }

  async informManagers() {
    return await request( {
      environment,
      type: 'query',
      name: 'informManagers',
      way: st_way
    })
  }

  async personalManagers() {
    return await request( {
      environment,
      type: 'query',
      name: 'personalManagers',
      way: st_way
    })
  }

  //members //////////////////////////////////////////////////////////////////////

  async invitedParticipants(tenderId) {
    let invitedParticipants = await import(members_way + 'invitedParticipants.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${invitedParticipants}`,
        variables: {
          tenderId: tenderId,
        }
      })
      .then(this.getInvitedParticipantsCallback)
      //.catch(error => Vue.prototype.$log_error(error.message))
  }
  getInvitedParticipantsCallback(response) {
    let invitedParticipants = response.data.invitedParticipants
    // Vue.prototype.$store.commit('setTreeView', treeView)
    return invitedParticipants
  }

  async subscibedUsers(tenderId, classificationCode) {
    let subscibedUsers = await import(members_way + 'subscibedUsers.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${subscibedUsers}`,
        variables: {
          tenderId, classificationCode
        }
      })
      .then((resp) => resp.data.subscibedUsers)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async accreditedSuppliers(tenderId) {
    let accreditedSuppliers = await import(members_way + 'accreditedSuppliers.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${accreditedSuppliers}`,
        variables: {
          tenderId: tenderId,
        }
      })
      .then((resp) => {
        return resp.data?.accreditedSuppliers?.map((resultItem) => {
          return {
            ...resultItem,
            groupId: resultItem.id ? resultItem.id : resultItem.groupId
          }
        }) ?? []
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  /**
  * Зберігає відхилення для кожної електронної пошти, про які шлюз повідомляє як помилки GraphQL (errorPolicy 'all').
  * @param {string[]} emails
  * @returns {Promise<{ users: Array, rejected: Array<{email: string, reason: string, suggestion?: string}>, warnings: Array<{email: string, reason: string}> }>}
  */
  async getParticipants(emails) {
    let getParticipants  = await import(members_way + 'getParticipants.graphql')
    const resp = await (await getApolloClient('/tenders'))
      .query({
        query: gql`${getParticipants}`,
        variables: {emails: emails},
        errorPolicy: 'all'
      })
    const { rejected, warnings, errors } = splitEmailReport(resp)
    if (errors.length && !resp.data?.getParticipants) {
      // not a per-email rejection and nothing to show: fail like the query without errorPolicy
      throw new Error(errors[0].message)
    }
    return { users: resp.data?.getParticipants || [], rejected, warnings }
  }

  /**
   * errorPolicy 'all': відхилення email-ів повертаються в rejected/warnings, а не кидаються.
   * @returns {Promise<{ invited: boolean, rejected: Array, warnings: Array, errors: Array }>}
   */
  async addInvitedParticipant(data) {
    let addInvitedParticipant  = await import(mutation_way + 'addInvitedParticipant.gql')
    const res = await (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${addInvitedParticipant}`,
        variables: {
          createParticipantListInput: data,
        },
        errorPolicy: 'all'
      })
    return { invited: !!res.data?.addInvitedParticipant, ...splitEmailReport(res) }
  }

  /**
   * errorPolicy 'all': відхилення email-ів повертаються в rejected/warnings, а не кидаються.
   * @returns {Promise<{ result: { success: boolean, messages: Array }, rejected: Array, warnings: Array, errors: Array }>}
   */
  async personalInvitation(emails, tenderId) {
    let personalInvitation  = await import(mutation_way + 'personalInvitation.gql')
    const res = await (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${personalInvitation}`,
        variables: {
          emails, tenderId
        },
        errorPolicy: 'all'
      })
    return { result: res.data?.personalInvitation || null, ...splitEmailReport(res) }
  }

  async invitedParticipantsAccreditations(categoryIds, supplierId) {
    if (!Vue.prototype.$store.getters.getGrowthBook?.invitedParticipantsAccreditations) {
      return []
    }
    let invitedParticipantsAccreditations = await import(members_way + 'invitedParticipantsAccreditations.gql')
    return (await getApolloClient('/accreditation'))
      .query({
        query: gql`${invitedParticipantsAccreditations}`,
        variables: { categoryIds, supplierId }
      })
      .then((resp) => resp.data?.invitedParticipantsAccreditations ?? [])
      .catch(error => Vue.prototype.$log_error(error.message))
  }




  //resources //////////////////////////////////////////////////////////////////////
  async searchClassifications(query) {
    let searchClassifications = await import(resources_way + 'searchClassifications.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${searchClassifications}`,
        variables: { query: query }
      })
      .then(this.searchClassificationsCallback)
  }
  searchClassificationsCallback(response) {
    let {classificationsFromTender, classifications, __typename } = response.data.searchClassifications

    function buildTree(flat, parentId = null) {
      return flat
        .filter(item => item.parentId === parentId)
        .map(item => ({
          ...item,
          children: buildTree(flat, item.id)
        }))
    }

    const classificationsTree = buildTree(classifications)

    return {
      classificationsFromTender,
      classifications: classificationsTree,
      __typename
    }
  }

  /**
   * DEPRECATED
   * used searchClassificationsCallback
   */
  async classifications(query) {
    let classifications = await import(resources_way + 'classifications.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${classifications}`,
        variables: { query: query }
      })
      .then((res) => res.data.classifications)
  }

  async getClassification(categories) {
    return await request( {
      environment,
      type: 'query' ,
      name: 'getClassification',
      variables: {categories},
      way: resources_way,
      has_catch: true} )
  }

  async subcategories(data) {
    let subcategories  = await import(resources_way + 'subcategories.gql')
    const variables = {}
    if (Array.isArray(data)) {
      variables.classificationCodes = data
    } else {
      variables.classificationCode = data
    }
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ subcategories }`,
        variables
      })
      .then(this.subcategoriesCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  subcategoriesCallback(response) {
    let subcategories = response.data.subcategories
    return subcategories
  }

  async resources(data) {
    let resources  = await import(resources_way + 'resources.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ resources }`,
        variables: {
          classificationCode: data,
        }
      })
      .then(this.resourcesCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  resourcesCallback(response) {
    let resources = response.data.resources
    return resources
  }

  async treeView() {
    let treeView = await import(resources_way + 'treeView.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${treeView}`,
      })
      .then(this.getTreeViewCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  getTreeViewCallback(response) {
    let treeView = response.data.treeView
    Vue.prototype.$store.commit('setTreeView', treeView)
    return treeView
  }




  //tender //////////////////////////////////////////////////////////////////////


  /**
   * За прапорцем getTenderPartialErrors (errorPolicy 'all') помилка окремого поля
   * (напр. nbuCurrency — НБУ недоступний) не відкидає тендер: дані беруться, помилки логуються.
   * Без даних тендеру — як і раніше, помилка → undefined
   */
  async getTender(id) {
    let getTender = await import(tender_way + 'getTender.gql')
    const partialErrors = Vue.prototype.$store?.getters?.getGrowthBook?.getTenderPartialErrors
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${getTender}`,
        variables: {id: +id},
        ...(partialErrors ? { errorPolicy: 'all' } : {}),
      })
      .then(response => {
        if (response.errors?.length) {
          if (!response.data?.getTender) {
            throw new Error(response.errors[0].message)
          }
          Vue.prototype.$log_error(`getTender ${id}: ${response.errors.map(error => error.message).join('; ')}`)
        }
        return this.getTenderCallback(response)
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  getTenderCallback(response) {
    let tender = response.data.getTender

    const isLotGroup = !!tender?.lotGroups?.length

    if (isLotGroup) {
      tender.lotGroups?.forEach((group, index) => {
        group.groupNumber = index + 1
      })
      tender?.bids?.forEach((bid) => {
        bid.bidDetails.forEach((detail) => {
          const group = tender.lotGroups?.find(lotGroup => lotGroup.innerLotIds && lotGroup.innerLotIds.includes(detail.lotId))
          detail.lotGroupNumber = group?.groupNumber ?? null
          detail.lotGroupTitle = group?.title ?? ''
        })
      })
    }

    Vue.prototype.$store.commit('setTender', tender)
    return tender
  }
  async getTenderReports(tenderId) {
    let getTender = await import(tender_way + 'getTenderReports.gql')
    const model = {
      tenderId
    }
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${getTender}`,
        variables: { model }
      })
      .then(res => res.data.getTenderReports)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async getTenderNameStatus(id) {
    let getTender = await import(tender_way + 'getTenderNameStatus.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${getTender}`,
        variables: {id: +id}
      })
      .then(res => res.data.getTender)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getEditingTender(tenderId) {
    let getTender = await import(tender_way + 'getEditingTender.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${getTender}`,
        variables: {tenderId: +tenderId}
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async tenderComments(tenderId) {
    let tenderComments = await import(tender_way + 'tenderComments.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${tenderComments}`,
        variables: {tenderId: tenderId}
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async tenderContactPersons() {
    let tenderContactPersons = await import(tender_way + 'tenderContactPersons.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${tenderContactPersons}`
      })
      .then(this.tenderContactPersonsCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  tenderContactPersonsCallback(response) {
    let tenderContactPersons = response.data.tenderContactPersons
    Vue.prototype.$store.commit('setTenderContactPersons', tenderContactPersons)
    return tenderContactPersons
  }

  async getAdditionalContactPeople() {
    let getAdditionalContactPeople = await import(tender_way + 'getAdditionalContactPeople.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${getAdditionalContactPeople}`
      })
      .then(this.getAdditionalContactPeopleCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  getAdditionalContactPeopleCallback(response) {
    let getAdditionalContactPeople = response.data.getAdditionalContactPeople
    Vue.prototype.$store.commit('setAdditionalTenderContactPersons', getAdditionalContactPeople)
    return getAdditionalContactPeople
  }

  async tendersSearch(params) {
    params.sort = params.sort || 'SMART_RANK'
    let tendersSearch = await import(tender_way + 'tendersSearch.gql')
    return (await getApolloClient('/tenders', null, true))
      .query({
        query: gql`${tendersSearch}`,
        variables: {tenderSearchParam: params.tenderSearchParam, additionalFilter: params.additionalFilter, page: params.page, size: params.size, sort: params.sort}
      })
      .then(res => {
        const result = res.data.tendersSearch

        const statusesOnCleararchiveDate =  [10, 11, 12]// https://app.clickup.com/t/869743af3  "Завершено", "закупівля не відбулась" або "акупівля відмінена"

        result?.tenders?.forEach((tenderItem) => {
          if (!statusesOnCleararchiveDate.includes(tenderItem.tenderStatusId)) {
            tenderItem.archiveDate = null
          }
        })


        return result
      })
  }

  async tendersStatistic(tenderSearchParam ) {
    let tendersStatistic = await import(tender_way + 'tendersStatistic.gql')
    return (await getApolloClient('/tenders', null, true))
      .query({
        query: gql`${tendersStatistic}`,
        variables: {tenderSearchParam}
      })
      .then(res => res.data.tendersStatistic)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getTenderAccess(tenderId) {
    //return ['ALLOW_SEND_PRICE_REQUEST', 'ALLOW_SEND_SUPPLIER_QUESTION']
    try {
      let getTenderAccess = await import(tender_way + 'getTenderAccess.gql')
      return (await getApolloClient('/tenders'))
        .query({
          query: gql`${getTenderAccess}`,
          variables: {tenderId: tenderId}
        })
        .then((resp) => resp.data.getTenderAccess)
        .catch(error => Vue.prototype.$log_error(error.message))
    } catch (e) {
      Vue.prototype.$log_error(e)
      return
    }
  }

  async tenderStatus(tenderId) {
    let tenderStatus = await import(tender_way + 'tenderStatus.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${tenderStatus}`,
        variables: {tenderId: tenderId}
      })
      .then((resp) => resp.data.tenderStatus)
      .catch(error => Vue.prototype.$log_error(error.message))
  }


  async getTenderStatuses() {
    return await request({
      environment,
      type: 'query' ,
      name: 'tenderStatuses',
      way: tender_way,
      has_catch: true
    }  )
  }

  async getCategoryTemplates() {
    return await request( {
      environment,
      type: 'query',
      name: 'getCategoryTemplates',
      way: tender_way,
      callback: (res) => res?.data ? res?.data?.getCategoryTemplates : res
    } )
  }
  async updateCategoryTemplate(model) {
    return await request( {
      environment, type: 'mutation',
      variables: {model},
      name: 'updateCategoryTemplate',
      way: mutation_way
    } )
  }
  async createCategoryTemplate(model) {
    return await request( {
      environment, type: 'mutation',
      variables: {model},
      name: 'createCategoryTemplate',
      way: mutation_way
    } )
  }
  async deleteCategoryTemplate(model) {
    return await request( {
      environment,
      type: 'mutation',
      variables: {model},
      name: 'deleteCategoryTemplate',
      way: mutation_way
    } )
  }

  async bidPriceRequestsByBidder( {tenderId, lotId,  bidderId }) {
    return await request({
      environment,
      type: 'query' ,
      name: 'bidPriceRequestsByBidder',
      way: tender_way,
      variables: {tenderId, lotId,  bidderId }
    }  )
  }

  async getCommercialOffer(id) {
    let getCommercialOffer = await import(tender_way + 'getCommercialOffer.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${getCommercialOffer}`,
        variables: {tenderId: id}
      })
      .then(this.getCommercialOfferrCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  getCommercialOfferrCallback(response) {
    return response.data.getCommercialOffer
  }


  async historyBidders(id) {
    let historyBidders   = await import(tender_way + 'historyBidders.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ historyBidders }`,
        variables: {tenderId: id}
      })
      .then((resp) => resp.data.historyBidders)
  }

  async historyLots(id) {
    let historyLots = await import(tender_way + 'historyLots.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ historyLots }`,
        variables: {tenderId: id}
      })
      .then((resp) => resp.data.historyLots)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async prequalification(id) {
    let prequalification = await import(tender_way + 'prequalification.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ prequalification }`,
        variables: {tenderId: id}
      })
      .then((resp) => resp.data.prequalification)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getTenderBidHistory(data) {
    let getTenderBidHistory = await import(tender_way + 'getTenderBidHistory.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ getTenderBidHistory }`,
        variables: {
          tenderId: data.tenderId,
          model: data.model
        }
      })
      .then((resp) => resp.data.getTenderBidHistory)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async tendersAgreements(tenderIds) {
    let tendersAgreements = await import(tender_way + 'tendersAgreements.gql')
    return (await getApolloClient('/tenders', null, true))
      .query({
        query: gql`${ tendersAgreements }`,
        variables: { tenderIds }
      })
      .then((resp) => resp.data.tendersAgreements)
      .catch(error => Vue.prototype.$log_error(error.message))
  }



  async tenderAgreeHistory(tenderId) {
    let tenderAgreeHistory = await import(tender_way + 'tenderAgreeHistory.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ tenderAgreeHistory }`,
        variables: { tenderId }
      })
      .then((resp) => resp.data.tenderAgreeHistory)
      .catch(error => Vue.prototype.$log_error(error.message))
  }


  async getBindedFrameAuctions(tenderId) {
    return await request({
      environment,
      type: 'query' ,
      name: 'getBindedFrameAuctions',
      variables: {tenderId},
      way: tender_way,
      has_catch: true
    })
  }


  async getFrameAuctionAdditionalInfo(tenderId) {
    return await request({
      environment,
      type: 'query' ,
      name: 'getFrameAuctionAdditionalInfo',
      variables: {tenderId},
      way: tender_way,
      has_catch: true
    })
  }


  async tenderStatusAndSchedule(id) {
    return await request( {
      environment,
      variables: {id},
      type: 'query',
      name: 'tenderStatusAndSchedule',
      way: tender_way,
      callback: (res) => res?.data ? res?.data?.getTender : res
    } )
  }




  //// criteria_way //////////////////


  async availableCards(tenderId) {
    let availableCards = await import(criteria_way + 'availableCards.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${availableCards}`,
        variables: { tenderId }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async infoAboutCriterionCard(criterionCardId) {
    let infoAboutCriterionCard = await import(criteria_way + 'infoAboutCriterionCard.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${infoAboutCriterionCard}`,
        variables: {criterionCardId}
      })
      .then((resp) => {
        const result = resp.data.infoAboutCriterionCard

        if (Array.isArray(result.criterias)) {
          result.criterias.forEach(criterion => {
            if (criterion.criterionControlType === 'TEXT') {
              criterion.criterionControlType = 'BIG_TEXT'
            }
            criterion.fixedValue = criterion.fixedValue ?? ''
            criterion.criterionKind = criterion.criterionKind ?? 'DEFAULT'
          })
        }
        if (result.reducedPriceFormula) {
          result.reducedPriceFormula = result.reducedPriceFormula.replace(/\^/g, '**')
        }
        return result
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }



  async getCriteriaCardTemplates() {
    return await request( {environment, type: 'query' , name: 'getCriteriaCardTemplates', way: criteria_way, has_catch: true} )
  }


  async deleteCriteriaCardTemplate(templateId) {
    return await request( {
      environment,
      type: 'mutation' ,
      name: 'deleteCriteriaCardTemplate',
      variables: {templateId},
      way: criteria_way
    } )
  }

  async updateCriteriaCardTemplate(model) {
    return await request( {
      environment, type: 'mutation' ,
      variables: {model},
      name: 'updateCriteriaCardTemplate',
      way: criteria_way
    } )
  }









  async tenderVisits(tenderId) {
    return await request({environment, type: 'query' , name: 'tenderVisits',variables: {tenderId}, way: tender_way, has_catch: false}  )
  }
  async resendInvitations(tenderId) {
    return await request({
      environment,
      type: 'query' ,
      name: 'resendInvitations',
      variables: {tenderId, typeId: 'RE_PUBLICATION'},
      way: tender_way,
      has_catch: true
    })
  }


  //mutations //////////////////////////////////////////////////////////////////////

  convertLotToSaveModel(lot) {
    lot.applicationRowsKey?.forEach(item => {
      delete item.__typename
    })
    lot.discounts?.forEach(item => {
      delete item.__typename
    })
    return {
      lotId: lot.lotId,
      lotNumber: lot.lotNumber || 0,
      lotSubject: lot.lotSubject,
      quantity: lot.quantity,
      minimalSubmitQuantity: lot.minimalSubmitQuantity,
      bidPriceLimit: lot.bidPriceLimit,
      measuringUnit: lot.measuringUnit,
      startAmount: lot.startAmount,
      discounts: lot.discounts,
      bidStep: lot.bidStep,
      description: lot.description,
      addressId: lot.addressId,
      applicationRowsKey: lot.applicationRowsKey || [],
      additionalFieldValues: lot.additionalFieldValues
    }
  }

  async createTender(data) {

    let tender = Object.assign({}, data)

    tender.lots = tender.lots.map(lot => this.convertLotToSaveModel(lot))
    tender.biddingTypeId = tender.biddingType.biddingTypeId
    tender.allowRaising = tender?.biddingType?.allowRaising ? !!tender.allowRaising : false
    delete tender.biddingType
    tender.areIndividualsAllowed ??= false
    tender.allowParticipantBidCancellation ??= false

    let createTender = await import( mutation_way + 'createTender.graphql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${createTender}`,
        variables: {
          tenderInput: tender
        }
      })
      .then(this.createTenderCallback)
  }

  createTenderCallback(response) {
    let newTender = response.data.createTender
    Vue.prototype.$store.commit('setNewTender', newTender)
    return newTender
  }

  async createSuppliersAddress(data) {
    let createSuppliersAddress = await import(mutation_way + 'createSuppliersAddress.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${createSuppliersAddress}`,
        variables: {
          address: data,
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async editTenderDraft(data) {
    let tender = Object.assign({}, data)
    const isGroupLotsEnabled = Vue.prototype.$ability.can('show', 'useGroupLots') && tender?.biddingType?.groupedLotsEnabled
    delete tender.tenderNumber
    delete tender.additionalCategories
    delete tender.category
    delete tender.tenderStatusId
    delete tender.__typename
    delete tender.organizerName
    delete tender.createdByExternalApi
    delete tender.hasBids
    let scheduledDate = tender?.tenderPublishedSchedule?.scheduledDate
    if ( scheduledDate ) {
      tender.scheduledStart ||= scheduledDate
    }
    delete tender.tenderPublishedSchedule
    delete tender.applicationBased
    tender.biddingTypeId = tender.biddingType.biddingTypeId
    tender.allowRaising = tender?.biddingType?.allowRaising ? !!tender.allowRaising : false
    tender.areIndividualsAllowed ??= false
    tender.allowParticipantBidCancellation ??= false
    delete tender.biddingType
    delete tender.hasRoute

    if (isGroupLotsEnabled) {
      tender.lotGroups?.forEach((group, groupIndex) => {
        tender.lotGroups[groupIndex].lots = tender.lotGroups[groupIndex].lots.map(lot => this.convertLotToSaveModel(lot))
      })
    } else if (!tender?.biddingType?.groupedLotsEnabled && tender?.lotGroups?.length) {
      tender.lots = tender.lotGroups.reduce((lots, group) => {
        const convertedLots = group.lots.map(lot => this.convertLotToSaveModel(lot))
        return [...lots, ...convertedLots]
      }, [])
      delete tender.lotGroups
    } else {
      tender.lots = tender.lots.map(lot => this.convertLotToSaveModel(lot))
    }

    tender.tenderProlongationRules?.forEach(item => {
      delete item.__typename
    })

    tender.additionalContactPersons?.forEach(item => {
      delete item.__typename
    })

    if (tender.lotGroups && Array.isArray(tender.lotGroups)) {
      tender.lotGroups = tender.lotGroups?.map(group => {
        delete group.__typename
        return group
      })
    }


    return await request(
      {
        environment,
        type: 'mutation',
        name: 'editTenderDraft',
        variables: {editedTender: tender}, way: mutation_way,
        callback: this.editTenderDraftCallback
      }
    )
  }

  editTenderDraftCallback(response) {
    let newTender = response.data.editTenderDraft
    Vue.prototype.$store.commit('setNewTender', newTender)
    return newTender
  }

  async publishTender(tenderId) {
    /*return {
      'data': {
        'publishTender': false
      },
      'extensions': {
        "code": "TenderBlockedOnEdit",
        'messages': [
          'Тендер знаходиться на погодженні'
        ]
      }
    }*/
    let publishTender = await import(mutation_way + 'publishTender.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${publishTender}`,
        variables: {
          tenderId: tenderId,
        }
      })
      .then(res => res)
  }

  async commercialOfferComment(id, text) {
    let commercialOfferComment = await import(mutation_way + 'commercialOfferComment.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${commercialOfferComment}`,
        variables: {
          tenderId: id,
          message: text
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async changeTenderWinner( model ) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'changeTenderWinner',
      variables: { model },
      way: mutation_way,
      has_catch: true
    } )
  }

  async changeTenderContactPerson( tenderId, newContactId ) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'changeTenderContactPerson',
      variables: { tenderId, newContactId },
      way: mutation_way,
    } )
  }

  // async chooseTenderWinner(data) {
  //   let chooseTenderWinner  = await import(mutation_way + 'chooseTenderWinner.gql')
  //   return (await getApolloClient('/tenders'))
  //     .mutate({
  //       mutation: gql`${chooseTenderWinner  }`,
  //       variables: {
  //         rows: data,
  //       }
  //     })
  //     .catch(error => Vue.prototype.$log_error(error.message))
  // }

  // async removeTenderWinner(data) {
  //   let removeTenderWinner  = await import(mutation_way + 'removeTenderWinner.gql')
  //   return (await getApolloClient('/tenders'))
  //     .mutate({
  //       mutation: gql`${removeTenderWinner  }`,
  //       variables: {
  //         rows: data,
  //       }
  //     })
  //     .catch(error => Vue.prototype.$log_error(error.message))
  // }


  async tenderCancel(id, text) {
    let tenderCancel  = await import(mutation_way + 'tenderCancel.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${tenderCancel  }`,
        variables: {
          cancelTender: {
            tenderId: id,
            reason: text
          },
        }
      })
      .then(res => {
        checkNeedMessage(res, res?.data?.tenderCancel)
        return res.data.tenderCancel
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async tenderFinish(id, text, addToSupplierNotification = false) {
    let tenderFinish  = await import(mutation_way + 'tenderFinish.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${tenderFinish  }`,
        variables: {
          completeTender: {
            tenderId: id,
            reason: text,
            addToSupplierNotification: addToSupplierNotification
          },
        }
      })
      .then(res => {
        checkNeedMessage(res, res?.data?.tenderFinish)
        return res.data.tenderFinish
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async tenderWithdrawal(tenderId, reason) {
    let tenderWithdrawal  = await import(mutation_way + 'tenderWithdrawal.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${tenderWithdrawal  }`,
        variables: {
          tenderId,
          reason
        }
      })
      .then(res => res.data.tenderWithdrawal)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async returnToRegistration(tenderId, orgId) {
    let returnToRegistration  = await import(mutation_way + 'returnToRegistration.gql')
    return (await getApolloClient('/tenders', orgId))
      .mutate({
        mutation: gql`${returnToRegistration  }`,
        variables: {
          tenderId
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async resentRequestToParticipants(tenderId) {
    let resentRequestToParticipants  = await import(mutation_way + 'resentRequestToParticipants.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${resentRequestToParticipants  }`,
        variables: {
          tenderId
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }


  async changeOrPostQuestion( questionId, tenderId, model) {
    let changeOrPostQuestion  = await import(mutation_way + 'changeOrPostQuestion.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ changeOrPostQuestion }`,
        variables: {
          model,
          tenderId,
          questionId
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async answerToParticipant( answer) {
    let answerToParticipant  = await import(mutation_way + 'answerToParticipant.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ answerToParticipant }`,
        variables: {
          answer
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async organisatorComment( message ) {
    let organisatorComment  = await import(mutation_way + 'organisatorComment.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ organisatorComment }`,
        variables: {
          message
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async prolongTender( {model, tenderId} ) {
    let prolongTender  = await import(mutation_way + 'prolongTender.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ prolongTender }`,
        variables: { model, tenderId }
      })
      .then(res => res?.data?.prolongTender)
      // .catch(error => Vue.prototype.$log_error(error.message))
  }
  async subscribeChat( chatId ) {
    let subscribeChat  = await import(mutation_way + 'subscribeChat.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ subscribeChat }`,
        variables: { chatId }
      })
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  async returnToAuction( { model, tenderId }  ) {
    let returnToAuction  = await import(mutation_way + 'returnToAuction.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ returnToAuction }`,
        variables: { model, tenderId }
      })
      .then(res => res?.data?.returnToAuction)
  }

  async republishTender( { model, tenderId }  ) {
    let republishTender  = await import(mutation_way + 'republishTender.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ republishTender }`,
        variables: { model, tenderId }
      })
      .then(res => res?.data?.republishTender)
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  async unSubscribeChat( chatId ) {
    let unSubscribeChat  = await import(mutation_way + 'unSubscribeChat.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ unSubscribeChat }`,
        variables: { chatId }
      })
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  async signLastVisit( chatId ) {
    let signLastVisit  = await import(mutation_way + 'signLastVisit.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ signLastVisit }`,
        variables: { chatId }
      })
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  async changeToAuction(tenderId, model) {
    let changeToAuction  = await import(mutation_way + 'changeToAuction.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ changeToAuction }`,
        variables: { tenderId, model }
      })
      .then(res => {
        checkNeedMessage(res, res?.data?.changeToAuction)
        return res.data.changeToAuction
      })
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  async deleteTender( tenderId, reason ) {
    let deleteTender  = await import(mutation_way + 'deleteTender.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ deleteTender }`,
        variables: { tenderId, reason }
      })
      .then(res => {
        return res?.data?.deleteTender
      })
      //.catch(error => Vue.prototype.$log_error(error.message))
  }

  async fillAuctionData( tenderId, model ) {
    let fillAuctionData  = await import(mutation_way + 'fillAuctionData.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ fillAuctionData }`,
        variables: { tenderId, model }
      })
      .then(res => {
        checkNeedMessage(res, res?.data?.fillAuctionData)
        return res?.data?.fillAuctionData
      })
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  async newPriceRequest( tenderId, model ) {
    return await request({
      environment,
      type: 'mutation',
      name: 'newPriceRequest',
      variables: {tenderId, model},
      way: mutation_way
    } )
  }

  async changeDecisionOnPrequalification( tenderId, model ) {
    let changeDecisionOnPrequalification  = await import(mutation_way + 'changeDecisionOnPrequalification.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ changeDecisionOnPrequalification }`,
        variables: { tenderId, model }
      })
      // .catch(error => Vue.prototype.$log_error(error.message))
  }


  async changeToAnalisisFromPrequalification( tenderId ) {
    let changeToAnalisisFromPrequalification  = await import(mutation_way + 'changeToAnalisisFromPrequalification.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ changeToAnalisisFromPrequalification }`,
        variables: { tenderId }
      })
  }

  async bidCancellation( model ) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'bidCancellation',
      variables: { model },
      way: mutation_way,
      has_catch: true
    })
  }

  async tenderUserAgree( userAgree ) {
    let tenderUserAgree  = await import(mutation_way + 'tenderUserAgree.gql')

    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${ tenderUserAgree }`,
        variables: { userAgree }
      })

      .then(res => res?.data?.tenderUserAgree)
      // .catch(error => Vue.prototype.$log_error(error.message))
  }


  async startTenderAgree( {tenderId, comment} ) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'startTenderAgree',
      variables: { tenderId, comment },
      way: mutation_way,
      has_catch: true
    })
  }


  async startAdditionalTenderAgree( model ) {
    return await request( {
      environment,
      type: 'query',
      name: 'startAdditionalTenderAgree',
      variables: { model },
      way: mutation_way,
      // has_catch: true
    })
  }


  async tenderSchedule( tenderId ) {
    return await request( {environment, type: 'mutation', name: 'tenderSchedule', variables: {tenderId}, way: mutation_way, has_catch: true} )
  }


  async createorUpdateCriteriaCard( {tenderId, createCriteriaCardInput} ) {
    return await request( {environment, type: 'mutation', name: 'createorUpdateCriteriaCard', variables: {tenderId, createCriteriaCardInput }, way: mutation_way} )
  }

  async addCriteriaCardTemplate( model ) {
    return await request( {environment, type: 'mutation', name: 'addCriteriaCardTemplate', variables: { model }, way: mutation_way} )
  }

  async addAdditionalCategoriesToTender( codes, tenderId) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'addAdditionalCategoriesToTender',
      variables: {
        codes,
        tenderId
      },
      way: mutation_way
    })
  }

  async addAdditionalCategoriesToTenderingStage( obj ) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'addAdditionalCategoriesToTenderingStage',
      variables: obj,
      way: mutation_way
    })
  }

  async changeOfferLanguage( tenderId, language ) {
    return await request( {environment, type: 'mutation', name: 'changeOfferLanguage', variables: {tenderId, language}, way: mutation_way, has_catch: true} )
  }

  async tenderEventHistory(tenderId) {
    return await request({environment, type: 'query' , name: 'tenderEventHistory',variables: {tenderId}, way: tender_way, has_catch: false}  )
  }

  async purchasiesRequest() {
    return await request({environment, type: 'query' , name: 'purchasiesRequest',variables: {}, way: st_way, has_catch: false}  )
  }

  async enterTheCabinet() {
    return await request( {environment, type: 'mutation', name: 'enterTheCabinet', variables: {}, way: mutation_way, has_catch: true} )
  }

  async redirectToOldCabinet(type) {
    return await request( {environment, type: 'mutation', name: 'redirectToOldCabinet', variables: {type}, way: mutation_way, has_catch: true} )
  }

  async getForm(formData) {
    delete formData.version
    return await request({environment, type: 'query' , name: 'getForm',variables: {formData}, way: tender_way, has_catch: false}  )
  }

  async copyTender( model ) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'copyTender',
      variables: {
        model
      },
      way: mutation_way
    })
  }

  async createNewTenderStage( model ) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'createNewTenderStage',
      variables: {
        model
      },
      way: mutation_way
    })
  }

  async addTenderToTemplate( tenderId, name) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'addTenderToTemplate',
      variables: {
        name,
        tenderId
      },
      way: mutation_way
    })
  }

  async removeTenderFromTemplate( tenderId) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'removeTenderFromTemplate',
      variables: {
        tenderId
      },
      way: mutation_way
    })
  }


  async addFilterTemplates( model) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'addFilterTemplates',
      variables: {
        model
      },
      way: mutation_way
    })
  }

  async editFilterTemplate( model) {
    let copy = Object.assign({}, model)
    delete copy.filterType
    return await request( {
      environment,
      type: 'mutation',
      name: 'editFilterTemplate',
      variables: {
        model: copy
      },
      way: mutation_way
    })
  }

  async deleteFilterTemplate( id) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'deleteFilterTemplate',
      variables: {
        id
      },
      way: mutation_way
    })
  }


  async createFrameAuction( model) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'createFrameAuction',
      variables: {
        model
      },
      way: mutation_way
    })
  }

  async changeAdditionalContactHidingStatus( model) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'changeAdditionalContactHidingStatus',
      variables: {
        model
      },
      way: mutation_way,
      has_catch: true
    })
  }

  async topOrganizationUnits(count) {
    return await request({
      environment,
      type: 'query',
      name: 'topOrganizationUnits',
      variables: {count},
      way: tender_way,
      has_catch: false}
    )
  }


















  /////////////////////////////////////           environment: '/suppliers',



  async submitForeignSupplierBid( model , files) {

    const getGqlString = (doc) => {
      return doc.loc && doc.loc.source.body
    }

    if (!files?.length) {
      return await request( {
        environment: '/suppliers',
        type: 'mutation',
        name: 'submitForeignSupplierBid',
        variables: {
          model
        },
        way: mutation_way
      })
    }

    let submit = await import(mutation_way + 'submitForeignSupplierBid.gql')
    let formdata = new FormData()

    const query = {
      query: getGqlString(gql`${submit}`),
      variables: { model , files: new Array(files.length) },
      operationName: null
    }
    let mapdata = {}
    formdata.append('operations', JSON.stringify(query))

    files.forEach((file, index) => {
      formdata.append(index, file, file.name)
      mapdata[index] = ['variables.files.' + index ]
    })

    formdata.append('map', JSON.stringify(mapdata))
    const uri = window.config.GrapgQlUrl + '/suppliers'

    // async getHeaders(type) {
    const token = await Vue.prototype.$auth.getUserToken()
    const headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${token ? token : ''}`,
      'Auth-Provider': 'SmartId',
      'OrganizationItId': sessionStorage.getItem('OrganizationItId'),
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Origin': '*',
      'culture': sessionStorage.language,
      'accept-language': sessionStorage.language,
      'href': window.location.href,
    }
    if (crypto?.randomUUID)  {
      headers.correlationId = crypto.randomUUID()
    }
    // return headers
    // }
    return await axios.post(uri, formdata,
      {
        headers: headers,
        onUploadProgress: this.listener
      }).then((res) => {
      // Як і Apollo без errorPolicy, віддаємо GraphQL-помилки (напр. FOREIGN_SUPPLIER_ERRROR_*) винятком
      const errors = res.data?.errors
      if (errors?.length) {
        throw Object.assign(new Error(errors[0].message), { graphQLErrors: errors })
      }
      return res.data?.data?.submitForeignSupplierBid
    })
  }

  // async submitForeignSupplierBid( model) {
  //   return await request( {
  //     environment: '/suppliers',
  //     type: 'mutation',
  //     name: 'submitForeignSupplierBid',
  //     variables: {
  //       model
  //     },
  //     way: mutation_way
  //   })
  // }


  async cancellForeignSupplierBids( model) {
    return await request( {
      environment: '/suppliers',
      type: 'mutation',
      name: 'cancellForeignSupplierBids',
      variables: {
        model
      },
      way: mutation_way
    })
  }

  async getOrganizationReports(reportType) {
    let model = reportType ? { reportType } : {}
    let getOrganizationReports = await import('./graphql/common/getOrganizationReports.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${getOrganizationReports}`,
        variables: {
          model
        },
      })
      .then(res => res.data.getOrganizationReports)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getCommonOrganizationReports() {
    let getCommonOrganizationReports = await import('./graphql/common/getCommonOrganizationReports.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${getCommonOrganizationReports}`,
      })
      .then(res => res.data.getCommonOrganizationReports)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async getSystemAlert() {
    return await request({
      environment: '/common',
      type: 'query' ,
      name: 'getSystemAlert',
      way: './graphql/common/',
      has_catch: true
    })
  }
  async getCurrentOrganizationDepartments() {
    const result = await request({
      environment,
      type: 'query' ,
      name: 'getCurrentOrganizationDepartments',
      way: tender_way,
      has_catch: true
    })
    return result?.sort((a, b) => a.title?.localeCompare(b.title)) || []
  }
  async getDepartments(organizationIds) {
    if (!organizationIds?.length || !organizationIds[0]) {
      return []
    }
    const result = await request({
      environment,
      type: 'query' ,
      name: 'getDepartments',
      variables: {
        organizationIds
      },
      way: tender_way,
      has_catch: true
    })
    return result?.sort((a, b) => a.title?.localeCompare(b.title)) || []
  }
  async getNbuCurrencyRate(currencyId) {
    if (SmarttenderApi.loadingNbuRates[currencyId]) {
      return
    }
    SmarttenderApi.loadingNbuRates[currencyId] = true
    const result = await request({
      environment,
      type: 'query' ,
      name: 'getNbuCurrencyRate',
      variables: { currencyId },
      way: tender_way,
      has_catch: true
    }).finally(() => {
      delete SmarttenderApi.loadingNbuRates[currencyId]
    })
    return result
  }
  async getYCToken() {
    return await request({
      environment: '/common',
      type: 'query' ,
      name: 'getYCToken',
      way: './graphql/common/',
      has_catch: true
    })
  }
}


/* async supplierAddress() {
  let supplierAddress = await import(st_way + 'supplierAddress.gql')
  return (await getApolloClient('/tenders'))
    .query({
      query: gql`${supplierAddress}`
    })
    .catch(error => Vue.prototype.$log_error(error.message))
} */
